import * as Yup from "yup";

export const creditEngineSchema = Yup.object({
  creditEngineName: Yup.string().required('Campo obrigatório'),
  creditEngineDescription: Yup.string().required('Campo obrigatório'),
  criteriaSets: Yup.array().of(
    Yup.object({
      name: Yup.string().required('Campo obrigatório'),
      description: Yup.string().required('Campo obrigatório'),
      criteriaRules: Yup.array().of(
        Yup.object({
          name: Yup.string().required('Campo obrigatório'),
          dataSource: Yup.string().required('Campo obrigatório'),
          field: Yup.string().required('Campo obrigatório'),
          operator: Yup.string().required('Campo obrigatório'),
          value: Yup.string().required('Campo obrigatório'),
          order: Yup.number().required('Campo obrigatório')
        })
      ).min(1, "Adicione pelo menos um critério")
    })
  ).min(1, "Adicione pelo menos um conjunto critério"),

})